import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import HeroSection from '../components/HeroSection';
import AboutPreview from '../components/AboutPreview';
import WorkSection from '../components/WorkSection';
import ServicesSection from '../components/ServicesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import PartnersSection from '../components/PartnersSection';
import ContactSection from '../components/ContactSection';
import { preloadImages } from '../utils/imagePreloader';
import './Home.css';

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Preload homepage images immediately
    const homepageImages = [
      'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&h=800&fit=crop&q=80',
      'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=800&fit=crop&q=80',
      'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=1200&h=800&fit=crop&q=80',
      'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=1200&h=800&fit=crop&q=80',
    ];
    
    preloadImages(homepageImages, {
      priority: 'high',
      stagger: false
    }).catch(() => {});
  }, []);

  return (
    <div className="home-page">
      <HeroSection />
      <AboutPreview />
      <WorkSection />
      <ServicesSection />
      <TestimonialsSection />
      <PartnersSection />
      <ContactSection />
    </div>
  );
};

export default Home;
